import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authExchange } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");

        if (!session_id) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const user = await authExchange(session_id);
                setUser(user);
                let next = "/";
                try {
                    next = sessionStorage.getItem("flexfeed_next") || "/";
                    sessionStorage.removeItem("flexfeed_next");
                } catch {}
                navigate(next, { replace: true, state: { user } });
            } catch (e) {
                navigate("/login", { replace: true });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-[100dvh] bg-[#0A0A0A] flex items-center justify-center">
            <Loader2 className="text-[#E1FF01] animate-spin" size={32} />
        </div>
    );
};

export default AuthCallback;
